import { render, staticRenderFns } from "./CallCenterNavbar.vue?vue&type=template&id=0c122842&scoped=true&"
import script from "./CallCenterNavbar.vue?vue&type=script&lang=js&"
export * from "./CallCenterNavbar.vue?vue&type=script&lang=js&"
import style0 from "./CallCenterNavbar.vue?vue&type=style&index=0&id=0c122842&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c122842",
  null
  
)

export default component.exports